import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../../Services/AuthContext';

type Props = {
  isAdmin: boolean;
  isMagasin:boolean;
  isMagasinLoin:boolean;
};

const UserHeader: React.FC<Props> = ({ isAdmin,isMagasin,isMagasinLoin }) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const goToAdmin = () => {
    navigate('/admin');
  };

  const goToMagasin=()=>{
    navigate('/magasin')
  }
  const goToMagasinLoin=()=>{
    navigate('/loinmagasin')
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
      <div className="container-fluid">
        <NavLink to="/" className="navbar-brand fw-bold">
          Magasin {user?.nom}
        </NavLink>

        <div className="d-flex align-items-center gap-3">

          {user ? (
            <>
              <span className="text-muted">Bienvenue, <strong>{user.nom}</strong></span>
              <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
                Déconnexion
              </button>
            </>
          ) : (
            <NavLink to="/login" className="btn btn-outline-primary btn-sm">
              Connexion
            </NavLink>
          )}

          {isAdmin && (
            <button onClick={goToAdmin} className="btn btn-sm btn-outline-primary">
              Espace Admin
            </button>
          )}
           {
            isMagasin && (
            <button onClick={goToMagasin} className="btn btn-sm btn-outline-primary">
              Espace Magasin
            </button>
            )
          }
          {
            isMagasinLoin && (
              <button onClick={goToMagasinLoin} className="btn btn-sm btn-outline-primary">
                Espace Magasin Loin
              </button>
            )
          }
        </div>
      </div>
    </nav>
  );
};

export default UserHeader;
